export default {"src":"/_next/static/media/tournament_clock.ec007707.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};